<template>
  <div id="app">
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        :key="$route.fullPath"
      ></router-view>
    </keep-alive>
    <!-- 不需要缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath">
    </router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // // 动态决定哪些组件需要被缓存
      // includedComponents:[]
    };
  },
};
</script>
<style lang="scss">
#app {
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
.container {
  width: 1280px;
  margin: 0 auto;
}
img {
  display: block;
}
.img_inline img {
  display: inline-block;
}
.flex {
  display: flex;
}
.flex_content_center {
  justify-content: center;
}
.flex_content_sb {
  justify-content: space-between;
}
.flex_content_end {
  justify-content: flex-end;
}
.flex_items_center {
  align-items: center;
}
.flex_wrap {
  flex-wrap: wrap;
}
.fb,
.color {
  transition: all 0.3s;
}
.fb:hover {
  font-weight: 500 !important;
}
.color:hover {
  color: #000 !important;
}
// 公用二级页面底纹 dxm
.bg_wrap {
  width: 100%;
  padding-bottom: 30px;
  min-height: 600px;
  //background: url("assets/imgs/sencon_bg.png") no-repeat;
  background-size: 100% auto;
}

// 箭头按钮
.btn-slide {
  width: 220px;
  height: 58px;
  color: #fff;
  background: #1d2379;
  border-radius: 29px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  .btn-main {
    display: block;
    text-align: center;
    height: 58px;
    line-height: 58px;
    position: relative;
    background: #1d2379;
    padding-left: 40px;
    box-sizing: border-box;
    .icon {
      width: 58px;
      height: 58px;
      position: absolute;
      top: 0;
      left: 40px;
      background: #1d2379;
      &::before {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        width: 26px;
        height: 26px;
        background: url("./assets/imgs/more.png") no-repeat;
        background-size: contain;
        transform: translate(-50%, -50%);
      }
    }
  }
  &:hover {
    padding-left: 43px;
    background-color: transparent;
    -webkit-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    .btn-main {
      padding: 0 20px;
      min-width: 180px;
      border-radius: 29px;
      -webkit-transition: all 0.3s ease-in-out;
      -o-transition: all 0.3s ease-in-out;
      transition: all 0.3s ease-in-out;
    }
    .icon {
      position: absolute;
      left: -43px;
      top: 0;
      border-radius: 29px;
      -webkit-transition: all 0.3s ease-in-out;
      -o-transition: all 0.3s ease-in-out;
      transition: all 0.3s ease-in-out;
    }
  }
}
// 右箭头
.btn-slide-right {
  .btn-main {
    padding-left: 0;
    padding-right: 20px;
    .icon {
      left: auto;
      right: 30px;
    }
  }
  &:hover {
    padding-left: 0;
    padding-right: 43px;
    .icon {
      left: auto;
      right: -43px;
    }
  }
}
// 小按钮
.small-btn {
  width: 138px;
  height: 40px;
  font-size: 14px;
  .btn-main {
    height: 40px;
    line-height: 40px;
    .icon {
      width: 40px;
      height: 40px;
      right: 12px;
      &::before {
        content: "";
        width: 18px;
        height: 18px;
      }
    }
  }
  &:hover {
    .btn-main {
      padding: 0 20px;
      min-width: 138px;
      border-radius: 29px;
    }
    .icon {
      right: -30px;
    }
  }
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1d2379;
  color: #fff;
}
@media only screen and (max-width: 1280px) {
  .container {
    width: 90%;
  }
}
@media only screen and (max-width: 767px) {
  .bg_wrap {
    width: 100%;
  }
  .small-btn {
    width: 1.75rem;
    height: 0.54rem;
    font-size: 0.23rem;
    .btn-main{
      height: 0.54rem;
      line-height: 0.54rem;
      padding-right: 0.25rem;
      .icon{
        width: 0.27rem;
        height: 0.27rem;
        right: 5px;
        top: 0.12rem;
      }
    }
    &:hover{
      .btn-main{
        min-width: 1.75rem;
        padding: 0;
      }
    }
  }
  .btn-slide-right:hover{
    padding-right: 0;
  }
}
</style>
